import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useGetSpotlightedBooks = (shouldFetch = true) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("books/spotlighted");
		return res.data;
	};

	return useQuery(["spotlighted-books"], () => fetch(), {
		...fetchConfig,
		enabled: shouldFetch,
	});
};

export default useGetSpotlightedBooks;
